import { useMemo } from 'react';

import { atom, useAtomValue } from 'jotai';

import useLocale from '@watershed/intl/frontend/useLocale';
import { CommandListItem } from '@watershed/shared-frontend/components/CommandPalette/kit/CommandList';
import CommandListPage from '@watershed/shared-frontend/components/CommandPalette/kit/CommandListPage';
import { useCommandPalettePageContext } from '@watershed/shared-frontend/components/CommandPalette/CommandPaletteContext';
import { PermissionlessFieldInfo } from '@watershed/shared-frontend/exchanges/gqlPermissionWarningExchange';

import GqlPermissionlessFieldPathsPage from './GqlPermissionlessFieldPathsPage';

export const permissionlessFieldAtom = atom<Array<PermissionlessFieldInfo>>([]);

export default function GqlPermissionlessFieldPage() {
  const locale = useLocale();
  const palette = useCommandPalettePageContext();
  const permissionlessFields = useAtomValue(permissionlessFieldAtom);

  const commands = useMemo(() => {
    return permissionlessFields
      .map((fieldInfo) => {
        return {
          id: fieldInfo.field,
          title: `[${fieldInfo.owner ?? 'Unowned'}] ${fieldInfo.field}`,
          description: `${fieldInfo.paths.length} caller${fieldInfo.paths.length === 1 ? '' : 's'}`,
          onSelect: () => {
            palette.push(GqlPermissionlessFieldPathsPage, { fieldInfo });
          },
        } satisfies CommandListItem<unknown>;
      })
      .toSorted((a, b) => a.title.localeCompare(b.title, locale));
  }, [permissionlessFields, locale, palette]);

  return (
    <CommandListPage
      commands={commands}
      searchPlaceholder="Search fields"
      enterActionLabel="View calling paths"
      searchMode="fuzzy"
    />
  );
}
